
import store from './old/store/store'
import { Toast } from "vant";
const network = function(){

  window.addEventListener("offline", function(){
    store.commit('SET_ISONLINE', false);
  },false);
  window.addEventListener("online", function(){
    store.commit('SET_ISONLINE', true);
    Toast('网络恢复');
  },false);
}


export default network;